// table info
export const tableHeaders = ["Name", "Description"];

export const columnNames = ["name", "name"];

export const viewRoute = "/file-maintenance/stock-categories/view";

export const searchColumn = "";
